import { render, staticRenderFns } from "./PromoCodeContainer.vue?vue&type=template&id=13dd2783&"
import script from "./PromoCodeContainer.vue?vue&type=script&lang=js&"
export * from "./PromoCodeContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports